/* unplugin-vue-components disabled */import script from "./DetailPayTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailPayTable.vue?vue&type=script&lang=ts&setup=true"

import "./DetailPayTable.vue?vue&type=style&index=0&id=7394e8e8&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7394e8e8"]])

export default __exports__